import { Modal, Button } from '@heroui/react'
import { useRouter } from '@tanstack/react-router'
import { Zap } from 'lucide-react'
import { useCreditsModalStore } from '../stores/use-credits-modal-store'

export function InsufficientCreditsModal() {
  const { isOpen, closeModal } = useCreditsModalStore()
  const router = useRouter()
  
  const handleTopup = () => {
    closeModal()
    router.navigate({ to: '/pricing' as any })
  }

  return (
    <Modal.Backdrop isOpen={isOpen} onOpenChange={(open) => !open && closeModal()} variant="blur">
      <Modal.Container>
        <Modal.Dialog aria-describedby="insufficient-credits-modal-description">
          <Modal.CloseTrigger />
          <Modal.Header>
            <Modal.Heading>Insufficient Credits</Modal.Heading>
          </Modal.Header>
          <Modal.Body className="pb-6">
            <div className="flex flex-col items-center justify-center gap-4 py-4 text-center">
              <div className="w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center">
                <Zap className="w-8 h-8 fill-current" />
              </div>
              <h3 className="text-xl font-bold">You're out of credits!</h3>
              <p id="insufficient-credits-modal-description" className="text-stone-500 text-sm">
                This action requires more credits than you currently have available.
                Top up your account or upgrade your plan to continue using premium features.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="flex-col sm:flex-row border-t border-divider pt-4">
            <Button variant="ghost" onPress={closeModal} className="w-full sm:w-auto">
              Cancel
            </Button>
            <Button variant="primary" onPress={handleTopup} className="w-full sm:w-auto font-medium">
              Top Up Credits
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  )
}
